// 突发事件处理
import request from '@/utils/httpRequest'

export function queryById (id) {
    return request({
        url: '/daily/wuyeDailyEmergency/queryById',
        method: 'get',
        params: {id: id}
    })
}

export function startFlow(params) {
    return request({
        url: '/daily/wuyeDailyEmergency/startFlow',
        method: 'post',
        data: params
    })
}